import React, { Component } from "react";
import { connect } from "react-redux";
import HothNav from '../nav/HothNav';
import "./Main.css";
// News
import Beacon from "../beacons/beacon/Beacon";

class MainLog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      splashComplete: false
    };
  }

  componentDidMount() {}

  render() {
    const mainClass = this.props.app.isMobile ? "mobileMain" : "desktopMain";
    const mainStyle =
      this.props.location.pathname === "/" ? { top: 0 } : { top: 25, left: 25 };
    return (
      <div>
        <Beacon  />
        <HothNav />
        <div className={mainClass} style={mainStyle}>
          <div className="gap" />
          {this.props.children}
          <div style={{ pointerEvents: "none" }} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  app: state.app,
  location: ownProps.location
});

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainLog);



// WEBPACK FOOTER //
// ./src/components/main/MainLog.js